export default "__VITE_ASSET__71a2c493__"